// @ts-ignore type
import AirPlaneCompanyIconData from '@/data/airplaneCompanyIcon.json';

export const AIRPLANE_COMPANY_ICON = AirPlaneCompanyIconData as Record<
  string,
  string
>;

export const EVENT_TYPE = [
  {
    label: '搜索地点',
    bgColor: '#F2F5CE',
    icon: 'md-search',
    color: '#1f2937',
    value: 'search',
  },
  {
    label: '添加交通',
    icon: ' md-airplane_ticket',
    bgColor: '#B8FBFF',
    color: '#287e83',
    value: 'airplane',
  },
  {
    label: '自定义活动',
    icon: ' md-featured_play_list',
    bgColor: '#f3f3f3',
    color: '#7a7a7a',
    value: 'custom',
  },
  {
    label: '交通或停留',
    icon: ' md-alt_route',
    bgColor: '#e0e3e8',
    color: '#7a7a7a',
    value: 'route',
  },
  {
    label: '景点',
    icon: 'md-landscape',
    bgColor: '',
    color: '#6DBD80',
    value: 'attraction',
  },
  {
    label: '住宿',
    icon: 'md-hotel',
    bgColor: '',
    color: '#64AADB',
    value: 'hotel',
  },
  {
    label: '吃喝',
    icon: 'md-restaurant_menu',
    bgColor: '',
    color: '#F1A44C',
    value: 'meal',
  },
  {
    label: '其他',
    icon: 'md-location_on',
    bgColor: '',
    color: '#666666',
    value: 'other',
  },
  // {
  //   label: '倒计时',
  //   icon: ' md-hourglass_empty',
  //   bgColor: '#f3f3f3',
  //   color: '#666666',
  // },
];

export const ROUTE_OPTIONS = [
  {
    label: '步行',
    icon: 'directions_walk',
    value: 'walk',
  },
  {
    label: '驾车',
    icon: 'directions_car',
    value: 'car',
  },
  {
    label: '公交',
    icon: 'directions_bus',
    value: 'bus',
  },
  {
    label: '停留',
    icon: 'mode_standby',
    value: 'stay',
  },
];

export const CURRENCY_CONFIG: Record<string, { unit: string; name: string, rate: number }> = {
  CNY: { unit: '￥', name: '人民币', rate: 1 },
  EGP: { unit: '￡', name: '埃及镑', rate: 0.1455 },
  'JPY': { unit: '¥', name: '日元', rate: 0.048 },
};
